module.exports = __webpack_public_path__ + "img/weya1.938e2d55.png";